import axios from "axios";
import { nordNxtApiEndpoint } from "../../config/config";
import getAuthHeader from "../../utils/getAuthHeader";

export default async function getNotifications() {
  const { data } = await axios.get(
    `${nordNxtApiEndpoint}/notification/unread-notification`,
    getAuthHeader(),
  );
  return data;
}
